import { useMainContext } from "../contexts/main";
import { CFlexBetween, TradeWrapper, DText, HText } from "../styles/CommonStyles";
import {ArrowDown, ArrowUp, MarketName} from "../styles/ChangeHeader";
import {formatNumber, getPairInTabletVariants} from "../utils/common"
import Text from "../utils/Text";
import Loading from "../components/common/Loading"
import { ChangeBox } from "../styles/BoxingStyles";
import {useWindowSize} from "../hooks/common/useWindowSize";
import {MOBILE_SIZE, TABLET_SIZE} from "../constants/common";
import Pairs from "./pairbox/Pairs";
import {PairsTabletBox} from "../styles/PairBoxStyles";
import {useTradeHeaderHook} from "../hooks/useTradeHeaderHook";
import {AnimatePresence} from "framer-motion";
import {useEffect} from "react";


const MarketChanges = () => {

    const { market, main: {lang} } = useMainContext()
    const { width } = useWindowSize()
    const {
        onMarketNameClicked,
        pairsInTabletMode,
        price,
        currentChange,
        loading
    } = useTradeHeaderHook()

    useEffect(() => {
        document.title = `${formatNumber(price?.tooman)} | ${market.coin?.toUpperCase()}/${market.pair?.toUpperCase()}`
    }, [price])

    return (
        <ChangeBox>
            <TradeWrapper>
                <MarketName onClick={onMarketNameClicked}>
                    <HText fontSize={width > TABLET_SIZE ? "1.2rem" : "1rem"}>
                        {`${market.coin?.toUpperCase()}/${market.pair?.toUpperCase()}`}
                    </HText>
                    { (width > MOBILE_SIZE && width < TABLET_SIZE) && (
                        pairsInTabletMode ?
                            <ArrowUp size={18} />
                            :
                            <ArrowDown size={18} />
                    )}
                </MarketName>
                <CFlexBetween width="16%">
                    <DText color={price.color} type="number">{formatNumber(price.tooman)}</DText>
                    <DText color={price.color} type="number">{formatNumber(price.usdt)} $</DText>
                </CFlexBetween>
                <CFlexBetween width="16%">
                    <DText><Text tid="24change" /></DText>
                    <DText
                        type="number"
                        _type="number"
                        color={
                            currentChange?._24change > 0 ? "#1ce087" : "#e9106c"
                        }>
                        {formatNumber(currentChange?._24change, 2)}%
                    </DText>
                </CFlexBetween>
                <CFlexBetween width="16%">
                    <DText><Text tid="7change" /></DText>
                    <DText
                        type="number"
                        _type="number"
                        color={
                            currentChange?._7change > 0 ? "#1ce087" : "#e9106c"
                        }
                    >
                        {formatNumber(currentChange?._7change, 2)}%
                    </DText>
                </CFlexBetween>
                <CFlexBetween width="16%">
                    <DText><Text tid="24high" /></DText>
                    <DText type="number">{formatNumber(currentChange?.max)} $</DText>
                </CFlexBetween>
                <CFlexBetween width="16%">
                    <DText><Text tid="24low" /></DText>
                    <DText type="number">{formatNumber(currentChange?.min)} $</DText>
                </CFlexBetween>
            </TradeWrapper>
            <Loading loading={loading} />
            <AnimatePresence exitBeforeEnter>
                {pairsInTabletMode &&
                    <PairsTabletBox variants={getPairInTabletVariants(lang)} animate="in" exit="out" initial="out">
                        <Pairs />
                    </PairsTabletBox>
                }
            </AnimatePresence>
        </ChangeBox>
    )
}


export default MarketChanges;
